import SingleCart from "./SingleCart";
import { useDispatch, useSelector } from "react-redux";
import styles from "./MyAccount.module.css";
import icon from "../../images/icon.png";
import deleteIcon from "../../images/delete.svg";
import { useState } from "react";
import db from "../../firebase";
import { doc, deleteDoc, setDoc } from "firebase/firestore";
import { updateUserCollections } from "../../store/actions";
import { v4 } from "uuid";

const CollectionSection = () => {
  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state.loggedUser);
  const collections = loggedUser.collections;
  const [activeCollection, setActiveCollection] = useState("");
  const [newCollection, setNewCollection] = useState("");
  const activeCollectionData = collections.filter(
    (item) => item.id === activeCollection
  );

  const addNewCollection = async () => {
    const randNumber = v4();
    const tempData = loggedUser.collections;
    const newData = {
      name: newCollection,
      id: randNumber,
      content: [],
    };
    if (!newCollection) {
      alert("Please enter a name first.");
      return;
    }
    await setDoc(
      doc(db, `user_data/${loggedUser.uid}/collections`, randNumber),
      newData
    ).then(() => {
      tempData.push(newData);
      dispatch(updateUserCollections(tempData));
      setNewCollection("");
      alert("Created Successfully!");
    });
  };

  return (
    <>
      {activeCollection === "" && (
        <div className={styles.addCollectionOuter}>
          <input
            type="text"
            className={styles.inputCollection}
            placeholder="New Collection Name"
            value={newCollection}
            onChange={(e) => setNewCollection(e.target.value)}
          />
          <button
            className={styles.addCollectionButton}
            onClick={() => addNewCollection()}
          >
            Add
          </button>
        </div>
      )}
      <div
        className={`${styles.cartOuter} ${
          activeCollection === "" ? styles.cartOuterHalf : styles.cartOuterFull
        }`}
      >
        {activeCollection !== "" ? (
          <SingleCollection
            name={activeCollectionData[0].name}
            data={activeCollectionData[0].content}
            activeCollection={activeCollection}
            setActiveCollection={setActiveCollection}
          />
        ) : collections.length > 0 ? (
          collections.map((item, index) => (
            <CollectionFolder
              key={index}
              item={item}
              setActiveCollection={setActiveCollection}
            />
          ))
        ) : (
          <div className={`${styles.nothingBox} py-5`}>
            You have nothing in your Collection.
          </div>
        )}
      </div>
    </>
  );
};

const SingleCollection = ({
  name,
  data,
  activeCollection,
  setActiveCollection,
}) => {
  return (
    <>
      <h4 className="text-white my-2 w-100 text-capitalize">
        {name}
        <span
          className="badge bg-danger rounded-pill ms-3 cursor-pointer"
          onClick={() => setActiveCollection("")}
        >
          Go Back
        </span>
      </h4>
      {data.map((item, index) => (
        <SingleCart
          key={index}
          img={item}
          activeCollection={activeCollection}
        />
      ))}
    </>
  );
};

const CollectionFolder = ({ item, setActiveCollection }) => {
  const dispatch = useDispatch();
  const loggedUser = useSelector((state) => state.loggedUser);
  const deleteCollection = async () => {
    await deleteDoc(
      doc(db, `user_data/${loggedUser.uid}/collections`, item.id)
    ).then(() => {
      dispatch(
        updateUserCollections(
          loggedUser.collections.filter((itemm) => itemm.id !== item.id)
        )
      );
      alert("Deleted Successfully!");
    });
  };
  return (
    <div className={styles.SingleCollection}>
      <img
        src={deleteIcon}
        alt="img"
        className={`${styles.SingleCollectionIcon} cursor-pointer`}
        onClick={() => deleteCollection()}
      />
      <img
        src={icon}
        alt="img"
        className={styles.SingleCollectionImg}
        onClick={() => setActiveCollection(item.id)}
      />
      <h3
        className={`${styles.SingleCollectionHeading} text-capitalize`}
        onClick={() => setActiveCollection(item.id)}
      >
        {item.name}
      </h3>
    </div>
  );
};

export default CollectionSection;
